import { billing } from '@transfeeradev/api-enums';
const invoiceStatus = billing.invoiceStatus;

export default {
  [invoiceStatus.PAID]: 'Paga',
  [invoiceStatus.OPEN]: 'Em aberto',
  [invoiceStatus.OVERDUE]: 'Em atraso',
  [invoiceStatus.PROTESTED]: 'Em atraso'
};
